import React from 'react';
import ErrorPage from './ErrorPage';

export default class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError:true });
  }
  render() {
    const { hasError } = this.state
    const { children } = this.props
    if (hasError) {
      return <ErrorPage/>;
    }
    return children;
  }
}